import AcademyIndexPage from '../../components/academy/indexPage/AcademyIndexPage';

export default AcademyIndexPage;
